<template>

    <div class="checkout_page">


        <!-- Ec breadcrumb start -->
        <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row ec_breadcrumb_inner">
                            <div class="col-md-6 col-sm-12">
                                <h2 class="ec-breadcrumb-title">{{ $t('Checkout') }}</h2>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <!-- ec-breadcrumb-list start -->
                                <ul class="ec-breadcrumb-list">
                                    <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>
                                    <li class="ec-breadcrumb-item active">{{ $t('Checkout') }}</li>
                                </ul>
                                <!-- ec-breadcrumb-list end -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ec breadcrumb end -->

        <!-- Ec checkout page -->
        <section class="ec-page-content section-space-p" v-if="cartItems.length > 0">
            <div class="container">
                <div class="row">
                    <div class="ec-checkout-leftside col-lg-8 col-md-12 ">
                        <!-- checkout content Start -->
                        <div class="ec-checkout-content">
                            <div class="ec-checkout-inner">


                                <div class="ec-sidebar-wrap ec-checkout-del-wrap">
                                    <!-- Sidebar Summary Block -->
                                    <div class="ec-sidebar-block">
                                        <div class="ec-sb-title">
                                            <h3 class="ec-sidebar-title">{{ $t('Delivery Address') }}</h3>
                                        </div>
                                        <div class="ec-sb-block-content">

                                            <div class="ec-page-content ec-vendor-uploads section-space-p">
                                                <div class="ec-vendor-dashboard-card ec-vendor-setting-card">
                                                    <div class="ec-vendor-card-body">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="ec-vendor-block-profile">

                                                                    <div
                                                                        v-if="addresses?.data?.length > 0"
                                                                        class="ec-vendor-detail-block ec-vendor-block-email space-bottom-30"
                                                                        v-for="address in addresses?.data"
                                                                        :key="address.id">

                                                                        <h6 class="d-flex">

                                                                                <span class="ec-bill-option mb-1">
                                                                                    <span>

                                                                                        <input class="form-check-input"
                                                                                               type="radio" name="jack"
                                                                                               :id="'flexRadioDefault' + address.id"
                                                                                               v-model="item.address_id"
                                                                                               :value="address.id">

                                                                                        <label
                                                                                            :for="'flexRadioDefault' + address.id"
                                                                                            class="m-0">
                                                                                            {{ address?.name }}
                                                                                        </label>
                                                                                    </span>
                                                                                </span>

                                                                        </h6>

                                                                        <ul class="px-3">
                                                                            <li><b>{{ $t('Address') }} : </b>
                                                                                {{ address?.address }}
                                                                            </li>
                                                                            <li><b>{{ $t('Country') }} : </b>
                                                                                {{ address?.country?.name }}
                                                                            </li>
                                                                            <li><b>{{ $t('City') }} : </b>
                                                                                {{ address?.city?.name }}
                                                                            </li>
                                                                            <li><b>{{ $t('Phone') }} : </b>
                                                                                {{ address?.phone }}
                                                                            </li>
                                                                            <li><b>{{ $t('Postal code') }} : </b>
                                                                                {{ address?.postal_code }}
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                    <div v-else>
                                                                        <div class="alert alert-info">
                                                                            لا يوجد عناواين للشحن يرجى إضافة عنوان جديد للشحن.

                                                                            <router-link :to="{ name: 'addresses.index', params: { lang : $i18n.locale } }" >
                                                                                {{ $t('Addresses')}}
                                                                            </router-link>
                                                                        </div>
                                                                    </div>


                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div class="text-danger pt-3" v-if="isInvalid('address_id')">
                                                            {{ isInvalid('address_id') }}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                    </div>
                                    <!-- Sidebar Summary Block -->
                                </div>

                                <div class="ec-sidebar-wrap ec-check-pay-img-wrap">
                                    <!-- Sidebar Payment Block -->
                                    <div class="ec-sidebar-block">
                                        <div class="ec-sb-title">
                                            <h3 class="ec-sidebar-title">
                                                {{ $t('Payment Option') }}
                                            </h3>
                                        </div>
                                        <div class="ec-sb-block-content">

                                            <div>
                                                <b>{{ $t('Online payment') }}</b>
                                            </div>

                                            <img src="/images/more/telr.png"
                                                 class="blur-up lazyload mw-100" alt="" style="width: 300px">

                                        </div>
                                    </div>
                                    <!-- Sidebar Payment Block -->
                                </div>

                                <span class="ec-check-order-btn">
                                <button type="submit" class="btn btn-primary" @click="create">
                                    {{ $t('Place order') }}
                                </button>
                            </span>
                            </div>
                        </div>
                        <!--cart content End -->
                    </div>
                    <!-- Sidebar Area Start -->
                    <div class="ec-checkout-rightside col-lg-4 col-md-12">
                        <div class="ec-sidebar-wrap">
                            <!-- Sidebar Summary Block -->
                            <div class="ec-sidebar-block">
                                <div class="ec-sb-title">
                                    <h3 class="ec-sidebar-title">{{ $t('Order Summery') }}</h3>
                                </div>
                                <div class="ec-sb-block-content">
                                    <div class="ec-checkout-summary">

                                        <div>
                                            <span class="text-left">{{ $t('Subtotal') }}</span>
                                            <span class="text-right">
                                                <del v-if="capone.totals != null">
                                                        {{ subtotal }} {{ $t('SAR') }}
                                                </del>
                                                <template v-else>
                                                        {{ subtotal }} {{ $t('SAR') }}
                                                </template>
                                            </span>
                                        </div>

                                        <div v-if="capone.totals != null">
                                            <span class="text-left">{{ $t('Discount') }}</span>
                                            <span class="text-right">{{ capone?.totals?.discount }} {{ $t('SAR') }}</span>
                                        </div>
                                        <div v-if="capone.totals != null">
                                            <span class="text-left">{{ $t('Subtotal') }}</span>
                                            <b class="text-right text-success">{{ capone?.totals?.subtotal }} {{ $t('SAR') }}</b>
                                        </div>


                                        <div v-if="capone.totals != null">
                                            <span class="text-left">{{ $t('Tax') }}</span>
                                            <span class="text-right">{{ capone?.totals?.total_tax }} {{ $t('SAR') }}</span>
                                        </div>
                                        <div v-else>
                                            <span class="text-left">{{ $t('Tax') }}</span>
                                            <span class="text-right">{{ tax }} {{ $t('SAR') }}</span>
                                        </div>
                                        <div v-if="capone?.data?.free_shipping == true">
                                            <span class="text-left">{{ $t('Shipping and delivery') }}</span>
                                            <div class="text-right">

                                                <del>
                                                    {{ main.settings?.shipping_cost }} {{ $t('SAR') }}
                                                </del>
                                                <b class="text-success">
                                                        مجاناً
                                                </b>

                                            </div>
                                        </div>
                                        <div v-else>
                                            <span class="text-left">{{ $t('Shipping and delivery') }}</span>
                                            <span class="text-right">{{ main.settings?.shipping_cost }} {{ $t('SAR') }}</span>
                                        </div>

                                        <div class="ec-cart-coupan-content" >
                                            <form class="ec-cart-coupan-form w-100" name="ec-cart-coupan-form" method="post"
                                                  action="#"  @submit.prevent="applyCapone">
                                                <input class="ec-coupan" type="text" required=""
                                                       placeholder="كوبون الخصم" name="ec-coupan" v-model="item.coupon_code">
                                                <button class="ec-coupan-btn button btn-primary" type="submit"
                                                        name="subscribe" value="">تطبيق</button>
                                            </form>
                                        </div>

                                        <div class="alert alert-info alert-dismissible fade show  m-0 rounded-0" role="alert">تستغرق عملية الشحن ما بين ٣ حتى ٧ أيام عمل.<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>

                                        <div v-if="capone.totals != null">
                                            <span class="text-left">{{ $t('Total') }}</span>
                                            <span class="text-right">
                                                <del>
                                                    {{ total }} {{ $t('SAR') }}
                                                </del>
                                                {{ capone?.totals?.total }} {{ $t('SAR') }}
                                            </span>
                                        </div>

                                        <div class="ec-checkout-summary-total" v-else>
                                            <span class="text-left">{{ $t('Total') }}</span>
                                            <span class="text-right">{{ total }} {{ $t('SAR') }}</span>
                                        </div>
                                        <!--                                    -->
                                        <!--                                    <div>-->
                                        <!--                                        <span class="text-left">Coupan Discount</span>-->
                                        <!--                                        <span class="text-right"><a class="ec-checkout-coupan">Apply Coupan</a></span>-->
                                        <!--                                    </div>-->
                                        <!--                                    <div class="ec-checkout-coupan-content">-->
                                        <!--                                        <form class="ec-checkout-coupan-form" name="ec-checkout-coupan-form"-->
                                        <!--                                              method="post" action="#">-->
                                        <!--                                            <input class="ec-coupan" type="text" required=""-->
                                        <!--                                                   placeholder="Enter Your Coupan Code" name="ec-coupan" value="">-->
                                        <!--                                            <button class="ec-coupan-btn button btn-primary" type="submit"-->
                                        <!--                                                    name="subscribe" value="">Apply</button>-->
                                        <!--                                        </form>-->
                                        <!--                                    </div>-->

                                    </div>
                                    <div class="ec-checkout-pro">
                                        <div class="col-sm-12 mb-6" v-for="item in cartItems" :key="item.product?.id">
                                            <div class="ec-product-inner">
                                                <div class="ec-pro-image-outer p-0 ">
                                                    <div class=" border rounded-3 p-1">
                                                        <div class="image text-center">
                                                            <img class="main-image"
                                                                 :src="item.product?.image ?? '/images/spices-jar.jpeg'"
                                                                 :alt="item.product?.name" height="80"/>
                                                            <!--                                                        <img class="hover-image"-->
                                                            <!--                                                             :src="product.image ?? '/images/spices-jar.jpeg'"-->
                                                            <!--                                                             :alt="product.name" height="80" />-->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="ec-pro-content">
                                                    <h5 class="ec-pro-title p-0">
                                                        {{ item.product?.name }} × {{ item.product?.cart?.quantity }}
                                                    </h5>
                                                    <!--                                                <div class="ec-pro-rating">-->
                                                    <!--                                                    <i class="ecicon eci-star fill"></i>-->
                                                    <!--                                                    <i class="ecicon eci-star fill"></i>-->
                                                    <!--                                                    <i class="ecicon eci-star fill"></i>-->
                                                    <!--                                                    <i class="ecicon eci-star fill"></i>-->
                                                    <!--                                                    <i class="ecicon eci-star"></i>-->
                                                    <!--                                                </div>-->
                                                    <span class="ec-price">
<!--                                                    <span class="old-price">$95.00</span>-->
                                                    <span class="new-price">
                                                        {{ item.product?.price_tax }} {{ $t('SAR') }}
                                                    </span>
                                                </span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- Sidebar Summary Block -->
                        </div>



                    </div>

                </div>
            </div>
        </section>
        <div class="container" v-else>

            <div class="alert alert-danger">
                {{ $t('No items in cart') }}
            </div>
        </div>

    </div>

    <!--        &lt;!&ndash; Checkout section Start &ndash;&gt;-->
    <!--        <section class="checkout-section-2 section-b-space">-->
    <!--            <div class="container-fluid-lg">-->
    <!--                <form @submit.prevent="create">-->
    <!--                    <div class="col-lg-4">-->
    <!--                        <div class="right-side-summery-box">-->

    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                </form>-->
    <!--                <div class="alert alert-danger" v-else>-->
    <!--                    {{ $t('No items in gift box') }}-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </section>-->
    <!--        &lt;!&ndash; Checkout section End &ndash;&gt;-->

</template>

<script>

import {useToast} from "vue-toastification";

const toast = useToast();
import {mapGetters, mapActions} from 'vuex';
import CartButton from "./CartButton.vue";

export default {
    components: {CartButton},
    props: ['main'],
    data() {
        return {
            addresses: {},
            item: {},
            capone: {},
            validationErrors: null,
        }
    },
    created() {
        this.getAddresses();
    },
    computed: {
        ...mapGetters(['cartItems']), // Map the cartItems getter

        subtotal() {
            return parseFloat(
                this.cartItems.reduce((subtotal, cartItem) => {
                    // إضافة القيمة فقط إذا كان product متاحًا
                    return cartItem.product ? subtotal + cartItem.quantity * cartItem.product.price : subtotal;
                }, 0)
            ).toFixed(2);
        },
        tax() {
            return parseFloat(
                (parseFloat(this.subtotal)+ parseFloat(this.main?.settings?.shipping_cost ?? 0) ) * 0.15 // الضريبة المضافة كنسبة من الإجمالي
                // (parseFloat(this.subtotal)+ parseFloat(this.main?.settings?.shipping_cost ?? 0) ) * 0.0 // الضريبة المضافة كنسبة من الإجمالي
            ).toFixed(2);
        },

        total() {
            return parseFloat(
                parseFloat(this.subtotal) +
                parseFloat(this.tax) +
                parseFloat(this.main?.settings?.shipping_cost ?? 0) // تكاليف الشحن إن وجدت
            ).toFixed(2);
        },
    },
    methods: {
        ...mapActions(['addToCart', 'removeFromCart']), // Map the addToCart and removeFromCart actions

        applyCapone() {
            this.capone = {};
            const id = toast.info(this.$t('Applying coupon ...'), {icon: 'fa-solid fa-download'});
            axios.post('coupons/check', this.item).then(response => {
                toast.dismiss(id);
                this.capone = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
        getAddresses() {

            const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-solid fa-download'});
            axios.get('addresses',).then(response => {
                toast.dismiss(id);
                this.addresses = response.data;
            }, response => {
                toast.dismiss(id);
            });

        },
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        create() {

            const id = toast.info(this.$t('Adding content...'), {icon: 'fa-solid fa-cloud-arrow-up'});

            const that = this;
            this.validationErrors = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post('orders',
                formData
            ).then(response => {
                toast.dismiss(id);

                console.log(response.data);
                console.log(response.data.message);
                toast.success(response.data.message, {
                    timeout: 3000,
                }, {icon: 'fa-solid fa-circle-check'});

                this.item = {};

                // this.$router.push({name: 'home'});
                window.location.href = '/payment?id=' + response.data.data.id + '';


            }).catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors;
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-exclamation'});
                }
            });

        }
    },
};

</script>
